module.exports = __webpack_public_path__ + "static/media/tipolator1x.d5eaf435.png";